var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#00a0e9;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 1.5,
    y: 2.5,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,0A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z",
    transform: "translate(3 3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.171,4.912v6.846A1.141,1.141,0,0,1,11.03,12.9H1.141A1.141,1.141,0,0,1,0,11.759V4.912A1.141,1.141,0,0,1,1.141,3.771H3.233l.292-.782A1.139,1.139,0,0,1,4.593,2.25H7.576a1.139,1.139,0,0,1,1.067.739l.295.782H11.03A1.141,1.141,0,0,1,12.171,4.912ZM8.938,8.336a2.853,2.853,0,1,0-2.853,2.853A2.855,2.855,0,0,0,8.938,8.336Zm-.761,0A2.092,2.092,0,1,1,6.086,6.244,2.1,2.1,0,0,1,8.178,8.336Z",
    transform: "translate(10 8.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a2330f80e2474e6dad8db0b5e0253875.svg";
export { ForwardRef as ReactComponent };